import { ENV } from 'gatsby-env-variables'
import { useContent } from 'modules/Content'
import useOriginTheme from 'hooks/useOriginTheme'
import segment from 'utils/segment'

const wppUrl = 'https://api.whatsapp.com/send?phone='

const UseWhatsAppJourney = () => {
  const { localOriginTheme } = useOriginTheme()

  const blok = useContent(`${localOriginTheme || 'recovery'}`, {
    hasTheme: false,
  })

  const whatsappContent = blok?.body?.find(
    (item) => item.component == 'lp_whatsapp'
  )

  const whatsappNumber =
    ENV === 'prod'
      ? `${whatsappContent?.whatsapp_number_prod}`
      : `${whatsappContent?.whatsapp_number_stg}`

  const handleClick = ({ track_message }) => {
    segment.track(track_message)

    const whatsappDataComplement = `${whatsappNumber}&text=${whatsappContent?.whatsapp_message}`

    window.open(`${wppUrl}${whatsappDataComplement}`)
  }

  return { handleClick }
}

export default UseWhatsAppJourney
